/* Analytics only: never sets consent, touches customer cookies or blocks commerce. */
(()=>{
'use strict';
if(window.ArtestaGalleryTracking||!window.ArtestaGalleryDelivery)return;
if(window.Shopify?.designMode||window.Shopify?.theme?.role!=='main')return;
const pending=new Map(),seen=new Set();
let country='';try{country=JSON.parse(document.getElementById('artesta-gallery-tracking-config').textContent).country;}catch{}
const allowed=()=>window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true;
let wasAllowed=allowed();
const storage={
 entries:prefix=>{const rows=[];for(let i=0;i<localStorage.length;i++){const k=localStorage.key(i);if(k?.startsWith(prefix))rows.push([k,localStorage.getItem(k)]);}return rows;},
 get:key=>localStorage.getItem(key),set:(key,value)=>localStorage.setItem(key,value),remove:key=>localStorage.removeItem(key)
};
const queue=window.ArtestaGalleryDelivery.createQueue({allowed,storage,send:async payload=>{
 const response=await fetch('/apps/artesta-gallery/event',{method:'POST',credentials:'same-origin',keepalive:true,
  signal:AbortSignal.timeout(8000),headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)});
 if(!response.ok){const error=Error('Event rejected');error.permanent=[400,409,413,415,422].includes(response.status);throw error;}
 return response.json();
}});
function flush(){
 if(!allowed())return;
 wasAllowed=true;
 for(const [event,occurred_at] of pending){
  if(seen.has(event)){pending.delete(event);continue;}
  if(!/^[A-Z]{2}$/.test(country))continue;
  const payload={version:2,event_id:crypto.randomUUID(),event,country,
   device:innerWidth<750||(innerWidth<1000&&innerHeight<500)?'mobile':'desktop',occurred_at};
  pending.delete(event);seen.add(event);
  void queue.add(payload).then(accepted=>{if(!accepted&&allowed()){seen.delete(event);pending.set(event,occurred_at);}});
 }
 void queue.flush();
}
window.ArtestaGalleryTracking={track(event){if(!['view','start','layout','artwork','review','cart'].includes(event)||seen.has(event))return;if(!pending.has(event))pending.set(event,new Date().toISOString());flush();},allowed};
document.addEventListener('visitorConsentCollected',()=>{if(allowed())flush();else{if(wasAllowed)pending.clear();wasAllowed=false;void queue.clear();}});
window.addEventListener('online',flush);window.addEventListener('pageshow',flush);
window.addEventListener('pagehide',()=>{void queue.flush();});
document.addEventListener('visibilitychange',()=>{if(!document.hidden)flush();});
window.addEventListener('storage',event=>{if(event.key?.startsWith(window.ArtestaGalleryDelivery.PREFIX))void queue.flush();});
let attempts=0;
function ready(){
 flush();
 if(typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed!=='function'&&attempts++<30)setTimeout(ready,1000);
}
if(window.Shopify?.loadFeatures&&!window.Shopify.customerPrivacy){try{window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],ready);}catch{}}
ready();window.dispatchEvent(new Event('artesta:gallery-tracking-ready'));
})();
